import { Util } from '@/modules/util'
import { Request } from '@/classes/Request'

// GET /ajax/quickpay/load/{guid}
// `invitation` is sent only by the enrollment invitation page: a cart paid in
// place there stays payable when the district has Quickpay turned off (DTA-966).
// `feeFor` (enrollment page only): work the processing fee out for the payment
// method the family has selected ('bank_account' | 'credit_card'), or for none
// ('none') before one is selected. Left out, the estimate carries the largest
// fee, which is what the wallet buttons charge (DTA-998).
export const quickpayLoad = async (
  guid: string,
  locale = 'en',
  invitation?: string,
  feeFor?: 'none' | 'bank_account' | 'credit_card'
) => {
  const response = await new Request().get(
    '/ajax/quickpay/load/' +
      guid +
      '?locale=' +
      encodeURIComponent(locale) +
      (invitation ? '&invitation=' + encodeURIComponent(invitation) : '') +
      (invitation && feeFor ? '&fee_for=' + feeFor : '')
  )
  return Util.Obj.keysToCamel(response.data) as any
}
